export default __webpack_public_path__ + "static/media/404-page-dark.ad83307d.png";